/** Wrapper-only id — opens TextTemplatePickerModal (not the Draw Text tool). */
export const TEXT_TEMPLATE_PICKER_ID = 'TextTemplatePicker';
